import template from './dashboard.component.html';
import controller from './dashboard.controller';

const dashboard = {
  template,
  controller,
};

export default dashboard;
